package com.dignicate.web.data.content.static.shared

import com.dignicate.web.domain.Language

class UiTextContentSource {
    companion object {
        fun aboutTitle(lang: Language): String = when (lang) {
            Language.Ja -> "私たちについて"
            else -> "About us"
        }

        fun servicesTitle(lang: Language): String = when (lang) {
            Language.Ja -> "事業内容"
            else -> "Our Services"
        }

        fun servicesDescription(lang: Language): String = when (lang) {
            Language.Ja -> "事業内容の概要です。詳細はプロジェクト要件に合わせて提案します。"
            else -> "Overview of our services. Details are customized based on project requirements."
        }

        fun productsTitle(lang: Language): String = when (lang) {
            Language.Ja -> "プロダクト"
            else -> "Products"
        }

        fun productsDescription(lang: Language): String = when (lang) {
            Language.Ja -> "私たちが手がけたアプリやプロトタイプの一部をご紹介します。"
            else -> "A selection of apps and prototype projects we've developed and maintained."
        }

        fun valuesTitle(lang: Language): String = when (lang) {
            Language.Ja -> "価値観"
            else -> "What we value"
        }

        fun valuesDescription(lang: Language): String = when (lang) {
            Language.Ja -> "私たちの仕事を支える考え方や行動指針です。"
            else -> "Principles and practices that guide how we work."
        }

        // UI setting labels
        fun languageLabel(lang: Language): String = when (lang) {
            Language.Ja -> "言語"
            else -> "Language"
        }

        fun languageOptionSystem(lang: Language): String = when (lang) {
            Language.Ja -> "システム"
            else -> "System"
        }

        fun languageOptionJa(@Suppress("unused") lang: Language): String = "日本語"

        fun languageOptionEn(@Suppress("unused") lang: Language): String = "English"

        fun themeLabel(lang: Language): String = when (lang) {
            Language.Ja -> "テーマ"
            else -> "Theme"
        }

        fun themeOptionSystem(lang: Language): String = when (lang) {
            Language.Ja -> "システム"
            else -> "System"
        }

        fun themeOptionLight(lang: Language): String = when (lang) {
            Language.Ja -> "ライト"
            else -> "Light"
        }

        fun themeOptionDark(lang: Language): String = when (lang) {
            Language.Ja -> "ダーク"
            else -> "Dark"
        }
    }
}
